import { AppRoutes } from "../../lib/common/AppRoutes";

export default function Workshops() {
  return (
    <div className="prose">
      <h1 className="hero__title">{AppRoutes.WORKSHOPS.title}</h1>
      <p>Coming Soon.</p>
    </div>
  );
}
